import { BrowserRouter, Routes } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { appEntryRoutes, appRoutes } from './routes/appRoutes'
import AnalyticsTracker from './components/AnalyticsTracker'
import DocumentTitleReset from './components/DocumentTitleReset'
import ScrollRestoration from './components/ScrollRestoration'
import CookieConsent from './components/CookieConsent'

// The only artifact that imports the auth/Supabase layer. Tag-gated in CI so it deploys after the backend.
export default function WebApp() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <DocumentTitleReset />
        <ScrollRestoration />
        <Routes>
          {appRoutes}
          {appEntryRoutes}
        </Routes>
        {/* Declared after <Routes> deliberately: React commits a subtree's effects
            before its later siblings', so the routed page's useSeo effect (which sets
            document.title) fires before this fires trackPageView — see AnalyticsTracker. */}
        <AnalyticsTracker platform="web_app" />
        <CookieConsent />
      </BrowserRouter>
    </AuthProvider>
  )
}
